<template>
  <div>
    <el-dialog
      :visible.sync="newDialog"
      center
      :close-on-click-modal="true"
      @close="cancelDialogD"
      custom-class="dialog_normalsuo"
      :append-to-body="true"
      v-if="newDialog"
    >
      <div class="detail_cont">
        <div class="flex_center margin-bottom10">
          <img
            class="imgReport"
            src="../../../assets/dialogIcoImg/reporterrorIcon.png"
            alt=""
          />
        </div>
        <h3>{{ $t("Toolbar.Reporterror") }}</h3>
        <div class="detail_cont_text" style="padding: 0px">
          {{ $t("dialog.ReportError.h1") }}
          <br />
          <br />
          <ul class="ulyuan">
            <li>{{ $t("dialog.ReportError.li1") }}</li>
            <li>{{ $t("dialog.ReportError.li2") }}</li>
            <li>{{ $t("dialog.ReportError.li3") }}</li>
            <li>{{ $t("dialog.ReportError.li4") }}</li>
          </ul>
          <br />
          {{ $t("dialog.ReportError.h2") }}
        </div>
        <div
          class="flex_center_between_box phoen_center_flex_warp"
          style="justify-content: center !important; margin-top: 20px"
        >
          <el-button
            class="btn_export"
            @click="(newDialogtwo = true), cancelDialogD()"
          >
            {{ $t("dialog.ReportError.next") }}</el-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- 点击阅读同意弹出 -->
    <el-dialog
      :visible.sync="newDialogtwo"
      center
      custom-class="dialog_normalsuo"
      :append-to-body="true"
      @close="cancelDialogA"
      v-if="newDialogtwo"
    >
      <div class="detail_cont">
        <div class="flex_center margin-bottom10">
          <img
            class="imgReport"
            src="../../../assets/dialogIcoImg/reporterrorIcon.png"
            alt=""
          />
        </div>
        <h3>{{ $t("Toolbar.Reporterror") }}</h3>
        <h1
          class="dialog_detail_check"
          style="margin-bottom: 20px; margin-top: 20px"
        >
          <el-checkbox v-model="checked">
            {{ $t("dialog.ReportError.Iamanemployeeofthissubjectcompany") }}
          </el-checkbox>
        </h1>
        <div class="add_list">
          <el-tabs type="card" class="tab_box" v-model="tabName">
            <el-tab-pane
              :label="$t('dialog.ReportError.Reportmycompany')"
              name="Reportmycompany"
              class="report_box"
            >
              <div
                class="cont_item"
                @click="
                  (finDialog = true), (form.uploadFiles = []), (filesList = [])
                "
              >
                {{ $t("dialog.ReportError.Updatedata") }}
              </div>
              <div
                class="cont_item"
                @click="
                  (reportDialog = true),
                    cancelDialogA(),
                    (form.uploadFiles = []),
                    (filesList = [])
                "
              >
                {{ $t("dialog.ReportError.Reportinformationerrors") }}
              </div>
            </el-tab-pane>
            <el-tab-pane
              :label="$t('dialog.ReportError.Reportotherscompany')"
              name="Reportotherscompany"
              class="report_box"
            >
              <div
                class="cont_item"
                @click="
                  (finDialog = true),
                    cancelDialogA(),
                    (form.uploadFiles = []),
                    (filesList = [])
                "
              >
                {{ $t("dialog.ReportError.Updatedata") }}
              </div>
              <div
                class="cont_item"
                @click="
                  (reportDialog = true),
                    (form.uploadFiles = []),
                    (filesList = [])
                "
              >
                {{ $t("dialog.ReportError.Reportinformationerrors") }}
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </el-dialog>
    <!-- 点击 Update data 后弹出 -->
    <el-dialog
      :visible.sync="finDialog"
      center
      custom-class="dialog_lg"
      :append-to-body="true"
      @close="cancelDialogB"
      v-if="finDialog"
    >
      <div class="detail_cont">
        <h3 class="margin-bottom20 margin-top20">
          {{ $t("dialog.ReportError.Financial") }}
        </h3>
        <el-form
          ref="Updateform"
          :model="form"
          class="form_box"
          label-position="left"
          label-width="170px"
        >
          <div class="formbodybox">
            <div class="flex_box flex_boxtwo margin-bottom20">
              <el-form-item
                :label="$t('dialog.ReportError.Pleaseprovidemoreinfo') + ':'"
                class="fin_top_item"
              >
                <el-select
                  v-model="form.pleaseProvideMoreInfo"
                  :placeholder="$t('dialog.ReportError.Select')"
                  class="fin_top_sel"
                >
                  <el-option
                    :label="item"
                    :value="item"
                    v-for="(item, index) in provideOptions"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                :label="$t('dialog.ReportError.Year') + ':'"
                class="fin_top_year"
              >
                <el-select
                  v-model="form.year"
                  :placeholder="$t('dialog.ReportError.Select')"
                  class="fin_top_sel"
                >
                  <el-option
                    :label="item"
                    :value="item"
                    v-for="(item, index) in yearOptions"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div
              class="fin_cont_box flex_center_between_box phoen_center_flex_warp"
              v-show="form.pleaseProvideMoreInfo != ''"
            >
              <div class="fin_modu_box">
                <div class="fin_modu">
                  <el-form-item
                    :label="$t('dialog.ReportError.TotalCurrentAssets') + ':'"
                  >
                    <el-input
                      autocomplete="off"
                      v-model="form.totalCurrentAssets"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('dialog.ReportError.CashBank') + ':'"
                  >
                    <el-input
                      autocomplete="off"
                      v-model="form.cashBank"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('dialog.ReportError.Accountreceivable') + ':'"
                  >
                    <el-input
                      autocomplete="off"
                      v-model="form.accountReceivable"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('dialog.ReportError.AdvancestoSuppliers') + ':'"
                  >
                    <el-input
                      autocomplete="off"
                      v-model="form.advancesToSuppliers"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('dialog.ReportError.Inventory') + ':'"
                  >
                    <el-input
                      autocomplete="off"
                      v-model="form.inventory"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('dialog.ReportError.Tobeappointedexpense') + ':'"
                  >
                    <el-input
                      autocomplete="off"
                      v-model="form.toBeAppointedExpense"
                    ></el-input>
                  </el-form-item>
                </div>
                <div class="fin_modu fin_modu_last">
                  <el-form-item
                    :label="
                      $t('dialog.ReportError.Totalnoncurrentassets') + ':'
                    "
                  >
                    <el-input
                      autocomplete="off"
                      v-model="form.totalNonCurrentAssets"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('dialog.ReportError.Longterminvestment') + ':'"
                  >
                    <el-input
                      autocomplete="off"
                      v-model="form.longTermInvestment"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('dialog.ReportError.Fixedassetsnetvalue') + ':'"
                  >
                    <el-input
                      autocomplete="off"
                      v-model="form.fixedAssetsNetValue"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="
                      $t('dialog.ReportError.Projectsunderconstruction') + ':'
                    "
                  >
                    <el-input
                      autocomplete="off"
                      v-model="form.projectsUnderConstruction"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="
                      $t('dialog.ReportError.Longtermtobeappointedexpenise') +
                      ':'
                    "
                  >
                    <el-input
                      autocomplete="off"
                      v-model="form.longTermToBeAppointedExpenise"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('dialog.ReportError.Deferredtaxdebit') + ':'"
                  >
                    <el-input
                      autocomplete="off"
                      v-model="form.deferredTaxDebit"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="fin_modu_box">
                <div class="fin_modu">
                  <el-form-item
                    :label="
                      $t('dialog.ReportError.Totalcurrentliabilities') + ':'
                    "
                  >
                    <el-input v-model="form.totalCurrentLiabilities"></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="
                      $t('dialog.ReportError.Totalcurrentliabilities') + ':'
                    "
                  >
                    <el-input v-model="form.accountPayable"></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('dialog.ReportError.Advancesfromclients') + ':'"
                  >
                    <el-input v-model="form.advancesFromClients"></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('dialog.ReportError.Salariespayable') + ':'"
                  >
                    <el-input v-model="form.salariesPayable"></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('dialog.ReportError.Taxespayable') + ':'"
                  >
                    <el-input v-model="form.taxesPayable"></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('dialog.ReportError.Otheraccountspayable') + ':'"
                  >
                    <el-input v-model="form.otherAccountsPayable"></el-input>
                  </el-form-item>
                </div>
                <div class="fin_modu fin_modu_last">
                  <el-form-item
                    :label="$t('dialog.ReportError.Totalequity') + ':'"
                  >
                    <el-input v-model="form.totalEquity"></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('dialog.ReportError.Paidupcapital') + ':'"
                  >
                    <el-input v-model="form.paidUpCapital"></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('dialog.ReportError.Capitalreserves') + ':'"
                  >
                    <el-input v-model="form.capitalReserves"></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('dialog.ReportError.Surplusreserves') + ':'"
                  >
                    <el-input v-model="form.surplusReserves"></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('dialog.ReportError.Undistrbutedporfit') + ':'"
                  >
                    <el-input v-model="form.undistrbutedPorfit"></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('dialog.ReportError.Totalassets') + ':'"
                  >
                    <el-input v-model="form.totalAssets"></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="fin_modu_box">
                <div class="fin_modu last">
                  <el-form-item
                    :label="$t('dialog.ReportError.Turnover') + ':'"
                  >
                    <el-input v-model="form.turnover"></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('dialog.ReportError.Costofgoodssold') + ':'"
                  >
                    <el-input v-model="form.costOfGoodsSold"></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('dialog.ReportError.Salestax') + ':'"
                  >
                    <el-input v-model="form.salesTax"></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('dialog.ReportError.Grossprofit') + ':'"
                  >
                    <el-input v-model="form.grossProfit"></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="
                      $t('dialog.ReportError.Otheroperatingprofils') + ':'
                    "
                  >
                    <el-input v-model="form.otherOperatingProfils"></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('dialog.ReportError.Salesexpense') + ':'"
                  >
                    <el-input v-model="form.salesExpense"></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('dialog.ReportError.Managementexpense') + ':'"
                  >
                    <el-input v-model="form.managementExpense"></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('dialog.ReportError.Financeexpense') + ':'"
                  >
                    <el-input v-model="form.financeExpense"></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('dialog.ReportError.Operatingprofit') + ':'"
                  >
                    <el-input v-model="form.operatingProfit"></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('dialog.ReportError.Nonoperatingincome') + ':'"
                  >
                    <el-input v-model="form.nonOperatingIncome"></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('dialog.ReportError.Profitbeforetax') + ':'"
                  >
                    <el-input
                      autocomplete="off"
                      v-model="form.profitBeforeTax"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('dialog.ReportError.Incometax') + ':'"
                  >
                    <el-input
                      autocomplete="off"
                      v-model="form.incomeTax"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('dialog.ReportError.Netincome') + ':'"
                  >
                    <el-input
                      autocomplete="off"
                      v-model="form.netIncome"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>

            <div class="fin_title">{{ $t("dialog.ReportError.Business") }}</div>
            <div class="bus_box">
              <el-form-item
                :label="$t('dialog.ReportError.Noofemployees') + ':'"
              >
                <el-input
                  autocomplete="off"
                  v-model="form.noOfEmployees"
                ></el-input>
              </el-form-item>
              <el-form-item
                :label="$t('dialog.ReportError.Coremanagement') + ':'"
              >
                <el-input
                  autocomplete="off"
                  v-model="form.coreManagement"
                ></el-input>
              </el-form-item>
              <el-form-item
                :label="$t('dialog.ReportError.Corebusinessactivites') + ':'"
              >
                <el-input
                  autocomplete="off"
                  v-model="form.coreBusinessActivites"
                  type="textarea"
                  :rows="5"
                ></el-input>
              </el-form-item>
            </div>
            <div class="bus_box2">
              <el-form-item :label="$t('dialog.ReportError.IntBusiness')">
                <div class="bus_box2_box">
                  <el-select
                    v-model="form.intBusiness"
                    :placeholder="$t('dialog.ReportError.Select')"
                  >
                    <el-option
                      :label="item"
                      :value="item"
                      v-for="(item, index) in intBusOptions"
                      :key="index"
                    ></el-option>
                  </el-select>
                  <el-input
                    autocomplete="off"
                    class="m_l"
                    v-model="form.intBusiness1"
                    :placeholder="
                      $t('dialog.ReportError.Pleasedescribeyouractivites')
                    "
                  ></el-input>
                  <el-input
                    autocomplete="off"
                    class="m_l"
                    v-model="form.activites2"
                    :placeholder="
                      $t('dialog.ReportError.Pleasedescribeyouractivites')
                    "
                  ></el-input>
                  <el-input
                    autocomplete="off"
                    class="m_l"
                    v-model="form.intBusiness3"
                    :placeholder="
                      $t('dialog.ReportError.Pleaselistcountriesyoudobusine')
                    "
                  ></el-input>
                </div>
              </el-form-item>
              <el-form-item
                :label="$t('dialog.ReportError.Corecompetency') + ':'"
              >
                <el-checkbox-group
                  v-model="form.coreCompetency"
                  class="check_box"
                >
                  <el-checkbox
                    v-for="competency in CompetencyList"
                    :label="competency"
                    :key="competency"
                    >{{ competency }}</el-checkbox
                  >
                </el-checkbox-group>
              </el-form-item>
            </div>
            <el-form-item
              :label="$t('dialog.ReportError.Businessoutlook') + ':'"
              class="out_item"
            >
              <el-select
                v-model="form.businessOutlook"
                :placeholder="$t('dialog.ReportError.Select')"
              >
                <el-option
                  :label="item"
                  :value="item"
                  v-for="(item, index) in busOptions"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('dialog.ReportError.Uploadfiles') + ':'">
              <el-upload
                class="upload-demo"
                action="fakeaction"
                ref="uploadFile"
                :http-request="hanldUploadFile"
                :before-remove="handleRemove"
                v-model="form.uploadFiles"
                :file-list="filesList"
              >
                <el-button slot="trigger">{{
                  $t("dialog.ReportError.Upload")
                }}</el-button>
              </el-upload>
            </el-form-item>
          </div>

          <div class="btn_box_dialog margin-top30">
            <!-- <el-button class="btn_cancel" @click="cancel()">{{ $t("dialog.ReportError.Cancel") }}</el-button> -->

            <el-button class="btn_export" @click="onSubmit()">{{
              $t("dialog.ReportError.Submit")
            }}</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>

    <!-- 点击 Report information errors 后弹出 -->
    <el-dialog
      :visible.sync="reportDialog"
      center
      custom-class="dialog_normalsuo"
      :append-to-body="true"
      @close="cancelDialogC"
      v-if="reportDialog"
    >
      <div class="detail_cont report_box">
        <h3 class="margin-bottom20">
          {{ $t("dialog.ReportError.DataProblems") }}
        </h3>
        <div class="rep_list">
          <el-form ref="reportForm" :model="reportForm" class="report_form">
            <div class="report_item">
              <div v-for="(report, index) in addReportList" :key="index">
                <div class="report_form_box">
                  <el-form-item
                    :label="$t('dialog.ReportError.Pleaseprovidemoreinfo')"
                    class="margin-bottom20"
                  >
                    <el-select
                      v-model="report.subject"
                      :placeholder="
                        $t('dialog.ReportError.Selectthedatacategoryyoureport')
                      "
                      @change="subjectChange(report.subject)"
                      style="width: 100%"
                    >
                      <el-option
                        :label="item"
                        :value="item"
                        v-for="(item, index) in subjectOptions"
                        :key="index"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    :label="$t('dialog.ReportError.CorrectInformation')"
                    class="margin-bottom20"
                  >
                    <el-input
                      autocomplete="off"
                      v-model="report.demand"
                      type="textarea"
                      class="limit_box"
                      maxlength="500"
                      @input="inputChange(report.demand)"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('dialog.ReportError.Uploadfiles')"
                    class="txtUpload"
                  >
                    <el-upload
                      class="upload-demo"
                      style="display: inline-block"
                      :limit="3"
                      action="fakeaction"
                      ref="uploadFiletwo"
                      :on-exceed="handleExceed"
                      :http-request="
                        (params) => hanldUploadFiletwo(params, index)
                      "
                      :before-remove="
                        (params, list) => handleRemovetwo(params, list, index)
                      "
                      v-model="report.uploadFiles"
                      :file-list="report.filesList"
                    >
                      <el-button slot="trigger">{{
                        $t("dialog.ReportError.Upload")
                      }}</el-button>
                    </el-upload>
                  </el-form-item>
                </div>
              </div>
              <div class="btn_box_dialog margin-top20">
                <!-- <el-button class="btn_cancel" @click="cancelReport()"
                  >{{ $t("dialog.ReportError.Cancel") }}</el-button
                > -->
                <el-button
                  class="btn_export"
                  :class="disabledReport ? 'btn_exporthui' : ''"
                  :disabled="disabledReport"
                  @click="onSubmitReport()"
                  >{{ $t("dialog.ReportError.Submit") }}</el-button
                >
              </div>
            </div>
          </el-form>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getReportError,
  getCompanySimpleInfo,
  getUpdateDataCompare,
  uploadFile,
  deleteFile,
  getCompanySnapshotSummary,
} from "@/api/companyApi.js";
import crypto from "@/utils/crypto";
export default {
  props: {
    showReport: {
      type: Boolean,
      default: false,
    },
    powerStatus: {
      type: Boolean,
      default: false,
    },
    Company: {
      type: Object,
      default: {},
    },
    companynameen: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      coId:"",
      tabName: "Reportmycompany",
      finDialog: false,
      reportDialog: false,
      newDialogtwo: false,
      form: {
        pleaseProvideMoreInfo: "",
        year: new Date().getFullYear(),
        totalCurrentAssets: "",
        cashBank: "",
        accountReceivable: "",
        advancesToSuppliers: "",
        inventory: "",
        toBeAppointedExpense: "",
        totalNonCurrentAssets: "",
        longTermInvestment: "",
        fixedAssetsNetValue: "",
        projectsUnderConstruction: "",
        longTermToBeAppointedExpenise: "",
        deferredTaxDebit: "",
        totalCurrentLiabilities: "",
        accountPayable: "",
        advancesFromClients: "",
        salariesPayable: "",
        taxesPayable: "",
        otherAccountsPayable: "",
        totalEquity: "",
        paidUpCapital: "",
        capitalReserves: "",
        surplusReserves: "",
        undistrbutedPorfit: "",
        totalAssets: "",
        turnover: "",
        costOfGoodsSold: "",
        salesTax: "",
        grossProfit: "",
        otherOperatingProfils: "",
        salesExpense: "",
        managementExpense: "",
        financeExpense: "",
        operatingProfit: "",
        nonOperatingIncome: "",
        profitBeforeTax: "",
        incomeTax: "",
        netIncome: "",
        noOfEmployees: "",
        coreManagement: "",
        coreBusinessActivites: "",
        intBusiness3: "",
        intBusiness1: "",
        intBusiness2: "",
        intBusiness: "",
        coreCompetency: [],
        businessOutlook: "",
        uploadFiles: [],
      },
      type: "701",
      filesList: [],
      provideOptions: ["CNY", "EURO", "USD"],
      yearOptions: [], //['2022', '2021', '2020', '2019', '2018', '2017', '2016', '2015', '2014', '2013', '2012', '2011', '2010', '2009', '2008'],
      busOptions: ["Good", "Not optimistic", "Unsure"],
      CompetencyList: [
        "Patent",
        "Trademark",
        "Copyright",
        "Software copyright",
        "High-tech",
      ],
      intBusOptions: ["Yes", "No"],
      subjectOptions: [
        "COMPANY SNAPSHOT",
        "COMPANY PROFILE",
        "MANAGEMENT",
        "OWNERSHIP",
        "BUSINESS OPERATIONS",
        "PERFORMANCE",
        "IMPORT&EXPORT",
      ],
      disabledReport1: true,
      disabledReport2: true,
      disabledReport: true,
      reportForm: { subject: "", demand: "" },
      addReportList: [
        { subject: "", demand: "", uploadFiles: [], filesList: [] },
      ],
      checked: false,
    };
  },
  computed: {
    newDialog: {
      get() {
        return this.showReport;
      },
      set(newValue) {},
    },
    companyName: {
      get() {
        return this.companynameen;
      },
      set(newValue) {},
    },
  },
  created() {
    this.getYears();
    this.getCompanySnapshotSummaryApi();
  },
  methods: {
    // 文件上传限制
    handleExceed() {
      this.$message.warning(
        `The current limit is to select 3 files, with a total of ${
          this.form.uploadFiles.length + 1
        } files selected`,
      );
    },
    async setData() {
      const params = {
        companyName: this.companyName,
        companyId: this.$route.query.id3a,
        demand: JSON.stringify(this.form),
        type: this.checked ? 701 : 7,
      };
      let res = await getUpdateDataCompare(params);
      if (res && res.code) {
        this.$message({
          message: res.msg,
          center: true,
          type: "success",
        });
      }
    },
    //获取年 2008-2023
    getYears() {
      const loadYear = new Date().getFullYear();
      const n = loadYear - 2007;
      for (var i = 0; i < n; i++) {
        const year = loadYear - i;
        this.yearOptions.push(year);
      }
    },
    //关闭弹窗
    cancelDialogA() {
      this.newDialogtwo = false;
    },
    cancelDialogB() {
      this.finDialog = false;
    },
    cancelDialogC() {
      this.reportDialog = false;
    },
    cancelDialogD() {
      this.newDialog = false;
      this.$emit("closeReportDialog", false);
    },
    closeDialog() {
      (this.form = {
        pleaseProvideMoreInfo: "",
        year: new Date().getFullYear(),
        totalCurrentAssets: "",
        cashBank: "",
        accountReceivable: "",
        advancesToSuppliers: "",
        inventory: "",
        toBeAppointedExpense: "",
        totalNonCurrentAssets: "",
        longTermInvestment: "",
        fixedAssetsNetValue: "",
        projectsUnderConstruction: "",
        longTermToBeAppointedExpenise: "",
        deferredTaxDebit: "",
        totalCurrentLiabilities: "",
        accountPayable: "",
        advancesFromClients: "",
        salariesPayable: "",
        taxesPayable: "",
        otherAccountsPayable: "",
        totalEquity: "",
        paidUpCapital: "",
        capitalReserves: "",
        surplusReserves: "",
        undistrbutedPorfit: "",
        totalAssets: "",
        turnover: "",
        costOfGoodsSold: "",
        salesTax: "",
        grossProfit: "",
        otherOperatingProfils: "",
        salesExpense: "",
        managementExpense: "",
        financeExpense: "",
        operatingProfit: "",
        nonOperatingIncome: "",
        profitBeforeTax: "",
        incomeTax: "",
        netIncome: "",
        noOfEmployees: "",
        coreManagement: "",
        coreBusinessActivites: "",
        intBusiness3: "",
        intBusiness1: "",
        intBusiness2: "",
        intBusiness: "",
        coreCompetency: [],
        businessOutlook: "",
        uploadFiles: [],
      }),
        (this.reportForm = { subject: "", demand: "" }),
        (this.addReportList = [
          { subject: "", demand: "", uploadFiles: [], filesList: [] },
        ]),
        (this.checked = false),
        (this.finDialog = false);
      this.newDialogtwo = false;
      this.reportDialog = false;
      this.checked = "";

      this.$emit("closeReportDialog", false);
    },
    //删除文件
    handleRemove(file, fileList) {
      let index = fileList.findIndex((item) => item.name == file.name);
      const str = this.form.uploadFiles[index];
      let i = str.lastIndexOf("/");
      let result = str.substr(i + 1, str.length);

      this.form.uploadFiles.splice(index, 1);
      let params = { fileName: result };
      deleteFile(params).then((res) => {
        if (res && res.code) {
          this.$message({
            message: res.msg,
            center: true,
            type: "success",
          });
        }
      });
    },
    handleRemovetwo(file, fileList, inde) {
      let index = fileList.findIndex((item) => item.name == file.name);
      const str = this.addReportList[inde].uploadFiles[index];
      let i = str.lastIndexOf("/");
      let result = str.substr(i + 1, str.length);
      this.addReportList[inde].uploadFiles.splice(index, 1);

      this.addReportList[inde].filesList.splice(index, 1);
      let params = { fileName: result };
      deleteFile(params).then((res) => {
        if (res && res.code) {
          this.$message({
            message: res.msg,
            center: true,
            type: "success",
          });
        }
      });
    },
    //上传文件
    hanldUploadFile(params) {
      let file = params.file;
      let form = new FormData();
      form.append("file", file);
      uploadFile(form).then((res) => {
        if (res && res.code) {
          this.form.uploadFiles.push(res.data);
        } else {
          this.$message({
            message: res.msg,
            center: true,
            type: "error",
          });
          let uid = file.uid;
          let idx = this.$refs.uploadFile.uploadFiles.findIndex(
            (item) => item.uid === uid,
          );
          this.$refs.uploadFile.uploadFiles.splice(idx, 1);
        }
      });
    },
    hanldUploadFiletwo(params, index) {
      let file = params.file;
      let form = new FormData();
      form.append("file", file);
      uploadFile(form).then((res) => {
        if (res && res.code) {
          this.form.uploadFiles.push(res.data);
          this.addReportList[index].uploadFiles.push(res.data);
          this.addReportList[index].filesList.push({
            name: file.name,
            url: res.data,
          });
        } else {
          this.$message({
            message: res.msg,
            center: true,
            type: "error",
          });
          let uid = file.uid;
          let idx = this.$refs.uploadFiletwo.uploadFiles.findIndex(
            (item) => item.uid === uid,
          );
          this.$refs.uploadFiletwo.uploadFiles.splice(idx, 1);
        }
      });
    },
    //提交update
    onSubmit() {
      if (!this.powerStatus) {
        this.newDialog = false;
        this.finDialog = false;
      } else {
        this.newDialog = false;
        this.finDialog = false;
        this.setData();
      }
    },
    //取消update
    cancel() {
      this.finDialog = false;
    },

    subjectChange(val) {
      val.length > 0
        ? (this.disabledReport1 = false)
        : (this.disabledReport1 = true);
      if (this.disabledReport1 == false && this.disabledReport2 == false) {
        this.disabledReport = false;
      } else {
        this.disabledReport = true;
      }
    },
    inputChange(val) {
      val.length > 0
        ? (this.disabledReport2 = false)
        : (this.disabledReport2 = true);
      if (this.disabledReport1 == false && this.disabledReport2 == false) {
        this.disabledReport = false;
      } else {
        this.disabledReport = true;
      }
    },

    getCompanySnapshotSummaryApi() { 
      getCompanySnapshotSummary({ id3a: this.$route.query.id3a }).then(
        (res) => {
          if (res.code == "200") { 
           this.coId= res.data.legalStatus?.id;
          }
        },
      ); 
    },
    //提交report
    onSubmitReport() {
      if (!this.powerStatus) {
        let type = 1;
        this.$parent.getOrdersAdd(type).then((res) => {
          if (res) {
            this.hanldSubmitReport();
          }
        });
      } else {
        this.hanldSubmitReport();
      }
    },
    async hanldSubmitReport() {
      this.newDialog = false;
      this.reportDialog = false;

      let list = this.addReportList;
      let arr = [];
      list.forEach((item) => {
        let obj = {};
        obj = {
          coId: this.coId,
          companyName: this.companyName,
          companyId: this.$route.query.id3a,
          subject: item.subject,
          demand: item.demand,
          attachment: JSON.stringify(item.uploadFiles),
          type: this.checked ? 601 : 6,
        };
        arr.push(obj);
      });
      let res = await getReportError(arr);
      if (res.code == 200) {
        this.$message({
          message: res.msg,
          center: true,
          type: "success",
        });
      }
    },
    //取消report
    cancelReport() {
      this.reportDialog = false;
    },
    //添加report表单
    addForReport() {
      const obj = { subject: "", demand: "", filesList: [], uploadFiles: [] };
      this.addReportList.push(obj);
      this.disabledReport = true;
      this.disabledReport1 = true;
      this.disabledReport2 = true;
    },
    //删除report表单
    delForReport(n) {
      this.addReportList.splice(n, 1);
    },
  },
};
</script>
<style scoped>
.tab_box /deep/ .el-tabs__header {
  margin-bottom: 0.7142857142857143rem;
}

.el-tabs--card > .el-tabs__header {
  border: none;
}

.tab_box /deep/ .el-tabs__header {
  width: 100%;
  box-shadow: 0rem 0.14285714285714285rem 0.42857142857142855rem
    0.07142857142857142rem rgba(10, 33, 57, 0.14);
  border-radius: 1rem;
}

.tab_box /deep/ .el-tabs__header {
  padding: 0.7857142857142857rem 1.1428571428571428rem;
  display: none;
}

.result_tab {
  padding: 1.4285714285714286rem;
}

.tab_box /deep/ .el-tabs__nav-wrap {
  width: 100%;
  height: 2rem;
  background: #f5f5f5;
  border-radius: 0.5714285714285714rem;
  border: 0.07142857142857142rem solid #cccccc;
}

.tab_box /deep/ .el-tabs__nav {
  width: 100%;
  border: none;
  padding: 0.14285714285714285rem 2rem;
  display: flex;
  justify-content: space-between;
}

.tab_box /deep/ .el-tabs__item {
  padding: 0 1.0714285714285714rem;
  width: 11.428571428571429rem;
  height: 1.4285714285714286rem;
  line-height: 1.4285714285714286rem;
  font-size: 0.8571428571428571rem;
  color: #8497ab;
  border: none;
  text-align: center;
}

.tab_box /deep/ .el-tabs__item:last-child {
  padding-right: 1.0714285714285714rem !important;
}

.tab_box /deep/ .el-tabs__item.is-active {
  background: #ff7600;
  box-shadow: 0rem 0.07142857142857142rem 0.14285714285714285rem 0rem #c44306;
  border-radius: 0.2857142857142857rem;
  font-family: "Arial Bold";
  color: #ffffff;
}

.tab_box /deep/.el-tabs__content {
  width: 100%;

  background: #ffffff;
}

.cont_item {
  position: relative;
  width: 100%;
  padding: 19px 20px;
  margin-bottom: 14px;
  font-size: 16px;
  color: #1a2332;
  line-height: 22px;
  background: #f5f5f5;
  background-image: url(../../../assets/img/reporterror/btn_ic9.png);
  background-repeat: no-repeat;
  background-size: 12px 22px;
  background-position: 700px center;
  cursor: pointer;
}
.cont_item:last-child {
  margin-bottom: 0;
}

::v-deep .el-dialog.dialog_lg {
  width: 1500px;
  background: #ffffff;
  border-radius: 30px;
}

.fin_title {
  font-family: "Arial Bold";
  margin-bottom: 14px;
  line-height: 30px;
  height: 30px;
  font-size: 20px;
  color: #1a2332;
}

.form_box /deep/ .el-input__inner,
.report_form /deep/ .el-input__inner {
  width: 100%;
  height: 50px;
  line-height: 30px;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #cccccc;
  font-size: 18px;
  padding: 10px !important;
}

.fin_top_sel /deep/ .el-input__inner {
  width: 380px;
  height: 50px;
  line-height: 30px;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #cccccc;
  font-size: 18px;
  padding: 10px !important;
}
.fin_top_item {
  margin: 0 !important;
}
.fin_top_year /deep/.el-form-item__label,
.fin_top_item /deep/.el-form-item__label {
  width: auto !important;
}

.fin_top_item /deep/ .el-form-item__content {
  margin-left: 240px !important;
}

.fin_top_year /deep/ .el-form-item__content {
  margin-left: 60px !important;
}

.fin_top_year {
  margin-left: 60px;
  margin-bottom: 0;
}

.fin_cont_box {
  gap: 24px;
}

.fin_modu {
  width: 460px;
  padding: 14px 10px;
  margin-bottom: 10px;
  background: #f5f5f5;
  border-radius: 5px;
  border: 1px solid #cccccc;
}
.fin_modu_last {
  padding-bottom: 45px;
}
.form_box /deep/ .fin_modu .el-form-item {
  margin-bottom: 10px;
}
.form_box /deep/ .fin_modu .el-form-item:last-child {
  margin-bottom: 0;
}
.form_box /deep/ .bus_box .el-form-item,
.form_box /deep/ .bus_box2 .el-form-item {
  margin-bottom: 20px;
}

.form_box /deep/ .el-form-item__content {
  line-height: 50px;
}

.form_box /deep/ .el-form-item__label {
  display: flex;
  align-items: center;
  height: 50px;
  line-height: 25px;
  margin-bottom: 0;
  word-break: keep-all;
  color: #1a2332 !important;
  padding-right: 10px;
  font-size: 18px;
}
.form_box /deep/ .el-select .el-icon-arrow-up:before {
  color: #8497ab !important;
}
.form_box /deep/ .el-textarea__inner {
  height: 100px;
  font-size: 18px;
}
.bus_box2_box {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.bus_box2_box /deep/ .m_l {
  width: 300px;
}
.bus_box2 /deep/ .el-form-item__content {
  display: flex;
}
.out_item /deep/ .el-input__inner,
.bus_box2 /deep/ .el-input__inner,
.bus_box2_box /deep/ .el-input__inner {
  width: 300px;
  height: 50px;
  line-height: 18px;
  font-size: 18px;
  padding: 16px !important;
  margin: 0 !important;
}

.form_box /deep/ .out_item {
  margin-bottom: 1.4285714285714286rem;
}

.form_box /deep/ .el-input__icon {
  height: auto;
}
.formbodybox {
  max-height: 506px;
  padding-right: 5px;
  overflow: scroll;
}

.upload-demo /deep/ .el-button {
  display: flex;
  width: 200px;
  height: 50px;
  line-height: 50px;
  background: #eeeeee;
  border-radius: 10px;
  border: 1px solid #eeeeee;
  color: #1290c9;
  font-size: 18px;
  font-family: "Arial Bold";
  padding: 0 !important;
  align-items: center;
  justify-content: center;
}
.check_box {
  margin-right: 40px;
}
.check_box /deep/ .el-checkbox__inner {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 1px solid #8497ab;
}

.report_form /deep/ .el-form-item__label,
.check_box /deep/ .el-checkbox__label {
  font-size: 18px !important;
  color: #1a2332;
}
.report_form /deep/ .el-form-item__label {
  margin-bottom: 10px !important;
}
.check_box /deep/ .el-checkbox__label {
  line-height: 50px;
}
.check_box /deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
.check_box /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #1290c9;
  border-color: #1290c9;
}

.check_box /deep/ .el-checkbox__inner::after {
  height: 16px;
  left: 6px;
  top: 10px;
  width: 8px;
}

.btn_box_dialog {
  display: flex;
  justify-content: center;
  gap: 40px;
  text-align: center;
}
.btn_box_dialog .btn_cancel,
.btn_box_dialog .btn_export {
  display: flex;
  width: 200px;
  height: 50px;
  line-height: 50px;
  border-radius: 10px;
  color: #ffffff;
  font-size: 18px;
  padding: 0 !important;
  align-items: center;
  justify-content: center;
}
.is-disabled.btn_exporthui {
  color: #8497ab !important;
}
.btn_box_dialog .btn_cancel {
  background: #8497ab;
  border: 1px solid #8497ab;
}
.btn_box_dialog .btn_export {
  background: #1290c9;
  margin-left: 0 !important;
}

.btn_cancel {
  background: #8497ab;
  border-radius: 10px;
  color: #ffffff;
  height: auto;
}
.upload-demo /deep/ .el-button span {
  font-family: "Arial Bold";
}
.add_btn {
  background: #1290c9;
  background-image: url(../../../assets/img/reporterror/add_ic.png);
}

.del_btn {
  background: #f56b6b;
  background-image: url("../../../assets/img/reporterror/del_ic.png");
}

.del_btn,
.add_btn {
  float: right;
  width: 1.8571428571428572rem;
  height: 1.8571428571428572rem;
  margin-top: -2.2857142857142856rem;
  background-repeat: no-repeat;
  background-size: 0.7142857142857143rem;
  background-position: center;
  border-radius: 50%;
}

.limit_box /deep/ .el-textarea__inner {
  height: 240px;
  font-size: 18px;
}

.detail_cont .el-upload-list__item {
  display: flex;
}

.el-upload-list__item-status-label {
  display: inline-block;
}

.el-upload-list__item:hover .el-upload-list__item-status-label {
  display: none;
}

.detail_cont .el-upload-list__item-status-label,
.detail_cont .el-upload-list__item .el-icon-close {
  position: static;
}

.detail_cont .el-upload-list__item .el-icon-close {
  line-height: 1.8571428571428572rem;
}

.detail_cont_text {
  word-break: keep-all;
  text-align: justify;
  font-size: 16px;
  color: #1a2332;
  line-height: 26px;
  padding-top: 20px;
}
.dialog_detail_check .el-checkbox .el-checkbox__label {
  width: 400px;
  display: inline-block;
  position: relative;
  font-size: 16px;
  color: #1a2332;
}

.dialog_detail_title {
  font-size: 1.4285714285714286rem;
  color: #1a2332;
  margin-bottom: 1.4285714285714286rem !important;
  font-family: "Arial Bold";
}

.dialog_detail_check .el-checkbox {
  display: flex;
  align-items: center;
  white-space: normal;
}

/deep/ .el-checkbox__input {
  white-space: normal;
}
.imgReport {
  width: 60px;
  height: 60px;
}
.btn_export {
  width: 180px;
  height: 50px;
  border-radius: 10px;
  font-size: 18px;
  line-height: 18px;
  padding: 0;
}
.el-select-dropdown__item {
  height: 40px;
  line-height: 40px;
  font-size: 18px !important;
}
.txtUpload /deep/ .el-form-item__label {
  line-height: 50px;
  margin-right: 20px;
  margin-bottom: 0 !important;
}
@media (max-width: 1920px) {
  .detail_cont_text {
    font-size: 16px;
    line-height: 20px;
    padding-top: 15px;
  }
  .imgReport {
    width: 45px;
    height: 45px;
  }
  .btn_export {
    width: 136px;
    height: 36px;
    border-radius: 8px;
    font-size: 16px;
    line-height: 16px;
  }
  .cont_item {
    padding: 13px 15px;
    margin-bottom: 10px;
    font-size: 16px;
    line-height: 19px;
    background-size: 8px 19px;
    background-position: 530px center;
  }
  ::v-deep .dialog_lg {
    width: 1200px !important;
  }
  .fin_title {
    margin-bottom: 12px;
    line-height: 24px;
    height: 24px;
    font-size: 18px;
  }

  .form_box /deep/ .el-input__inner,
  .report_form /deep/ .el-input__inner {
    height: 36px;
    line-height: 16px;
    border-radius: 5px;
    font-size: 16px;
    padding: 10px !important;
  }
  .form_box /deep/ .bus_box .el-form-item,
  .form_box /deep/ .bus_box2 .el-form-item {
    margin-bottom: 15px;
  }
  .fin_top_sel /deep/ .el-input__inner {
    width: 300px;
    height: 36px;
    line-height: 16px;
    border-radius: 5px;
    font-size: 16px;
    padding: 10px !important;
  }
  .fin_modu {
    width: 370px;
    padding: 10px;
  }
  .fin_modu_last {
    padding-bottom: 35px;
  }
  .fin_top_year {
    margin-left: 45px;
  }
  .fin_top_item /deep/ .el-form-item__content {
    margin-left: 220px !important;
  }

  .fin_top_year /deep/ .el-form-item__content {
    margin-left: 60px !important;
  }

  .fin_cont_box {
    gap: 12px;
  }
  .form_box /deep/ .el-form-item__content {
    line-height: 36px;
  }

  .form_box /deep/ .el-form-item__label {
    height: 36px;
    line-height: 18px;
    font-size: 16px;
  }
  .form_box /deep/ .el-textarea__inner {
    height: 75px;
    font-size: 16px;
  }
  .bus_box2_box /deep/ .m_l {
    width: 230px;
  }
  .out_item /deep/ .el-input__inner,
  .bus_box2 /deep/ .el-input__inner,
  .bus_box2_box /deep/ .el-input__inner {
    width: 230px;
    height: 36px;
    line-height: 16px;
    font-size: 16px;
    padding: 10px !important;
  }
  .el-select-dropdown__item {
    height: 34px;
    line-height: 34px;
    font-size: 16px !important;
  }
  .check_box {
    margin-right: 30px;
  }
  .check_box /deep/ .el-checkbox__label {
    line-height: 36px;
  }
  .report_form /deep/ .el-form-item__label,
  .check_box /deep/ .el-checkbox__label {
    font-size: 16px !important;
  }
  .btn_box_dialog .btn_cancel,
  .btn_box_dialog .btn_export,
  .upload-demo /deep/ .el-button {
    width: 150px;
    height: 36px;
    line-height: 36px;
    border-radius: 7px;
    font-size: 16px;
  }
  .check_box /deep/ .el-checkbox__inner {
    width: 16px;
    height: 16px;
  }
  .check_box /deep/ .el-checkbox__inner::after {
    height: 16px;
    width: 8px;
    left: 5px;
    top: 10px;
  }
  .limit_box /deep/ .el-textarea__inner {
    height: 180px;
    font-size: 16px;
  }
  .txtUpload /deep/ .el-form-item__label {
    line-height: 36px;
    margin-right: 15px;
  }
}
@media (max-width: 1439px) {
  ::v-deep .el-dialog {
    margin-top: 67px !important;
  }
  .detail_cont_text {
    font-size: 14px;
    line-height: 18px;
    padding-top: 12px;
  }
  .imgReport {
    width: 40px;
    height: 40px;
  }
  .btn_export {
    width: 120px;
    height: 32px;
    border-radius: 6px;
    font-size: 14px;
    line-height: 14px;
  }
  .cont_item {
    padding: 11px 14px;
    margin-bottom: 8px;
    font-size: 14px;
    line-height: 18px;
    background-size: 8px 18px;
    background-position: 480px center;
  }
  ::v-deep .dialog_lg {
    width: 1000px !important;
  }
  .fin_title {
    margin-bottom: 10px;
    line-height: 20px;
    height: 20px;
    font-size: 16px;
  }

  .form_box /deep/ .el-input__inner,
  .report_form /deep/ .el-input__inner {
    height: 32px;
    line-height: 14px;
    font-size: 14px;
    padding: 9px !important;
  }
  .form_box /deep/ .bus_box .el-form-item,
  .form_box /deep/ .bus_box2 .el-form-item {
    margin-bottom: 12px;
  }

  .fin_top_sel /deep/ .el-input__inner {
    width: 260px;
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    padding: 9px !important;
  }
  .fin_modu {
    width: 310px;
  }
  .fin_modu_last {
    padding-bottom: 30px;
  }
  .fin_top_year {
    margin-left: 40px;
  }
  .fin_top_item /deep/ .el-form-item__content {
    margin-left: 170px !important;
  }

  .fin_top_year /deep/ .el-form-item__content {
    margin-left: 45px !important;
  }

  .fin_cont_box {
    gap: 10px;
  }
  .form_box /deep/ .el-form-item__content {
    line-height: 32px;
  }

  .form_box /deep/ .el-form-item__label {
    height: 32px;
    line-height: 16px;
    font-size: 14px;
  }
  .form_box /deep/ .el-textarea__inner {
    height: 67px;
    font-size: 14px;
  }
  .bus_box2_box /deep/ .m_l {
    width: 190px;
  }
  .out_item /deep/ .el-input__inner,
  .bus_box2 /deep/ .el-input__inner,
  .bus_box2_box /deep/ .el-input__inner {
    width: 190px;
    height: 32px;
    line-height: 14px;
    font-size: 14px;
    padding: 9px !important;
  }
  .el-select-dropdown__item {
    height: 30px;
    line-height: 30px;
    font-size: 14px !important;
  }
  .check_box {
    margin-right: 26px;
  }
  .check_box /deep/ .el-checkbox__label {
    line-height: 32px;
  }
  .report_form /deep/ .el-form-item__label,
  .check_box /deep/ .el-checkbox__label {
    font-size: 14px !important;
  }
  .btn_box_dialog .btn_cancel,
  .btn_box_dialog .btn_export,
  .upload-demo /deep/ .el-button {
    width: 130px;
    height: 32px;
    line-height: 32px;
    border-radius: 6px;
    font-size: 14px;
  }
  .check_box /deep/ .el-checkbox__inner {
    top: -1px;
    width: 14px;
    height: 14px;
  }
  .check_box /deep/ .el-checkbox__inner::after {
    height: 16px;
    width: 8px;
    left: 5px;
    top: 9px;
  }
  .limit_box /deep/ .el-textarea__inner {
    height: 160px;
    font-size: 14px;
  }
  .txtUpload /deep/ .el-form-item__label {
    line-height: 32px;
    margin-right: 12px;
  }
}
</style>
